interface CheckIconProps {
  size?: number;
}

export default function CheckIcon({ size = 20 }: CheckIconProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="none"
    >
      <path 
        d="M16.6667 5L7.50004 14.1667L3.33337 10" 
        stroke="#F47B27" 
        strokeWidth="1.66667" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
